<template>
	<div class="row mobileMargin-b10 px-1">
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
			<div v-if="bottom" class="horizontalBreaker"></div>
			<div class="row between-md between-lg middle-md middle-lg">
				<div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
					<p class="textUppercase textSml whitespace-nowrap">
						{{ label }} <span class="fontHeavy textGreen textSml">{{ count }}</span>
					</p>
				</div>
				<div class="col-xs-12 col-sm-8 col-md-9 end-xs middle-sm middle-md middle-lg">
					<pagination
						:model-value="pageSize"
						:current-page="currentPage"
						:total-pages="pages"
						:page-sizes="pageSizes"
						@update:model-value="$emit('update:pageSize', $event)"
						@page-change="$emit('page-change', $event)"
					/>
				</div>
			</div>
			<div v-if="!bottom" class="horizontalBreaker"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		label: String,
		count: Number,
		pageSize: Number,
		currentPage: Number,
		bottom: Boolean,
		pages: Array,
		pageSizes: {
			type: Array,
			default: () => [10, 25, 100]
		}
	},
	emits: ['page-change', 'update:pageSize', 'update:currentPage']
}
</script>
